import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { editorPropTypes } from './propTypes';

export const separator = Symbol('separator');

export const ToolbarButton = ({ item, editor }) => {
  const handleClick = useCallback(event => {
    event.preventDefault();
    return item.action ? item.action(editor, event) : null;
  }, [item, editor]);

  if (item === separator) {
    return <span className="editor-toolbar__separator" />;
  }

  let { isActive, icon, button } = item;

  if (isActive && typeof isActive === 'function') {
    isActive = isActive(editor);
  }
  if (icon && typeof icon === 'function') {
    icon = icon(editor, { isActive });
  }
  if (button && typeof button === 'function') {
    button = button(editor, { isActive });
  }

  if (button) {
    return (
      <div
        className={classnames('editor-toolbar__action', { 'editor-toolbar__action--active': isActive })}
        onMouseDown={item.action ? handleClick : null}
      >
        {button}
      </div>
    );
  }

  if (icon) {
    return (
      <div
        className={classnames('editor-toolbar__action', { 'editor-toolbar__action--active': isActive })}
        onClick={item.action ? handleClick : null}
      >
        {icon}
      </div>
    );
  }

  throw new Error('Either icon or button must be defined in toolbar element');
};

ToolbarButton.propTypes = {
  item: PropTypes.oneOfType([
    PropTypes.symbol,
    PropTypes.shape({
      isActive: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
      icon: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
      button: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    }),
  ]),
  editor: editorPropTypes,
};

const Toolbar = ({ actions, editor, readOnly }) =>
  !readOnly ? (
    <div className="editor-toolbar">
      {editor && actions.map((row, i) => (
        <div key={i} className="editor-toolbar__row">
          {row.map((item, j) => (<ToolbarButton key={`${i}-${j}`} item={item} editor={editor}/>))}
        </div>
      ))}
    </div>
  ) : null;

Toolbar.propTypes = {
  readOnly: PropTypes.bool.isRequired,
  actions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.element]),
      action: PropTypes.func,
      isActive: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
      icon: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
      button: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    }),
    PropTypes.oneOf([separator]),
  ]))).isRequired,
  editor: editorPropTypes,
};

export default Toolbar;
